/**
 * @generated SignedSource<<81b23a414f152b30ce6fb68622cec46e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type placementsQuery$variables = {
  id: string;
};
export type placementsQuery$data = {
  readonly placementsOutput: ReadonlyArray<{
    readonly id: string;
    readonly isEnabled: boolean;
    readonly modelID: number;
    readonly name: string;
  }>;
};
export type placementsQuery = {
  response: placementsQuery$data;
  variables: placementsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PlacementOutput",
    "kind": "LinkedField",
    "name": "placementsOutput",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "placementsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "placementsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b8491b3294aa2ce36cc58d856b8c222b",
    "id": null,
    "metadata": {},
    "name": "placementsQuery",
    "operationKind": "query",
    "text": "query placementsQuery(\n  $id: ID!\n) {\n  placementsOutput(id: $id) {\n    id\n    modelID\n    isEnabled\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "45d22b85038516786a02b7abeb9a2ac0";

export default node;
